// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"36":"af50a274","67":"110ef6b7","181":"ded68ef5"}[chunkId] + ".chunk.css";
};